export type ProcedureDates = { activeFrom: Date | string; activeTo: Date | string };
export type ProcedureStatus = "active" | "upcoming" | "archived";

/** Procedura trwa: activeFrom <= now <= activeTo (oba końce włącznie). */
export function isProcedureActive(procedure: ProcedureDates, now: Date = new Date()): boolean {
  const from = new Date(procedure.activeFrom);
  const to = new Date(procedure.activeTo);
  return now >= from && now <= to;
}

/**
 * Klasyfikacja procedury na potrzeby list (kolejność sprawdzeń jak dotychczas
 * na stronie głównej: najpierw "upcoming", potem "archived", reszta "active").
 */
export function getProcedureStatus(procedure: ProcedureDates, now: Date = new Date()): ProcedureStatus {
  if (new Date(procedure.activeFrom) > now) return "upcoming";
  if (new Date(procedure.activeTo) < now) return "archived";
  return "active";
}

/** Pierwsza aktualnie trwająca procedura, w jej braku pierwsza z listy. */
export function pickDefaultProcedure<T extends ProcedureDates>(procedures: T[], now: Date = new Date()): T | null {
  return procedures.find((procedure) => isProcedureActive(procedure, now)) ?? procedures[0] ?? null;
}
